import { Helix2000Character } from '../../shared/CharacterTypes';
import { calculateBaseStats, calculateHealthMana } from '../../shared/classes/ClassUtils';
import { learnedAbilitiesUpTo } from '../../shared/progression/abilityCurve';
import { bootSearchParams } from '../../config/boot/bootUrl';

/**
 * Apply query-parameter dev overrides (?level=60&hotbar=...&abilities=...)
 * to synthetic client-side dev player before first paint.
 */
export function applyDevUrlOverrides(player: Helix2000Character): void {
  try {
    const sp = bootSearchParams();
    const rawLevel = sp.get('level');
    if (rawLevel) {
      const level = Math.max(1, Math.min(60, parseInt(rawLevel, 10)));
      if (!isNaN(level) && level > 1) {
        player.level = level;
        const { maxHealth, maxMana } = calculateHealthMana(player.class, level);
        player.maxHealth = maxHealth;
        player.health = maxHealth;
        player.maxMana = maxMana;
        player.mana = maxMana;
        player.stats = calculateBaseStats(player.class, level);
        const curve = learnedAbilitiesUpTo(player.class, level);
        player.learnedAbilities = [...new Set([...(player.learnedAbilities || []), ...curve])];
      }
    }

    const rawAbilities = sp.get('abilities');
    if (rawAbilities) {
      const custom = rawAbilities.split(',').map((s) => s.trim()).filter(Boolean);
      player.learnedAbilities = [...new Set([...(player.learnedAbilities || []), ...custom])];
    }

    const rawHotbar = sp.get('hotbar');
    if (rawHotbar) {
      const slots = rawHotbar.split(',').map((s) => s.trim()).filter(Boolean);
      if (!player.actionBar) {
        player.actionBar = { slots: [], activeBar: 1 };
      }
      const bar = player.actionBar;
      slots.forEach((abilityId, idx) => {
        const slotNum = idx + 1;
        player.learnedAbilities = [...new Set([...(player.learnedAbilities || []), abilityId])];
        const existingSlot = bar.slots.find((s) => s.slot === slotNum);
        if (existingSlot) {
          existingSlot.abilityId = abilityId;
          existingSlot.type = 'ability';
        } else {
          bar.slots.push({
            slot: slotNum,
            abilityId,
            type: 'ability',
            key: slotNum === 10 ? '0' : String(slotNum),
          });
        }
      });
    }
  } catch {
    /* best-effort in test/headless environments */
  }
}
